import { useEffect, useState } from "react";
import { is } from "../helpers/is";

export const useDebounce = (value, ms): any => {
  const [debouncedValue, setDebouncedValue] = useState(null);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      if (is(String, value)) {
        setDebouncedValue(value);
      }
    }, ms);

    return () => {
      if (timer) {
        window.clearTimeout(timer);
      }
    };
  }, [ms, value]);
  return debouncedValue;
};
